import * as yup from 'yup';
import i18n from 'i18n';

export const requestAccessSchema = yup.object().shape({
    comment: yup.string()
      .min(20, () => i18n.t('website:auth.accessRequested.validation.commentMinLength'))
      .required(() => i18n.t('website:auth.accessRequested.validation.commentRequired')),
});